import React from 'react';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import { DOCUMENT_STATUS_OPTIONS } from '../../constants';

const DocumentStatusFilter = () => (
  <IconFilter
    hasApplyButton
    name="status"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={DOCUMENT_STATUS_OPTIONS}
  />
);

export default DocumentStatusFilter;
